import * as React from 'react';
const TanzaniaFlag = (props) => (
    <svg width="26px" height="26px" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" className="iconify iconify--twemoji" preserveAspectRatio="xMidYMid meet" {...props}>
        <path fill="#1EB53A" d="M4 5a4 4 0 0 0-4 4v15.627L26.456 5H4z" />
        <path fill="#00A3DD" d="M32 31a4 4 0 0 0 4-4V11.33L9.479 31H32z" />
        <path fill="#141414" d="M32 5h-2.532L0 26.638V27a4 4 0 0 0 4 4h2.467L36 9.318V9a4 4 0 0 0-4-4z" />
        <path fill="#FBD035" d="M26.456 5L0 24.627v2.011L29.468 5zM9.479 31L36 11.33V9.318L6.467 31z" />
    </svg>
);
export default TanzaniaFlag;
